import { cleanUrl, ipfs2md5, metaCache, stripFile } from "../../utils/index.js";
import React, { useMemo, useState } from "react";
import { uploadToCache } from "../../lib/api";
import MetaModal from "./MetaModal.jsx";
import * as imageConversion from "image-conversion";
import { imgErr } from "../../components/imgErrHandler/imgErrHandler";

/**
 * ZoomCard component.
 *
 * Displays a small thumbnail image of an NFT that expands on hover.
 * Used in OwnedTokens to show compact token previews.
 * Features:
 * - Caching of IPFS images to local CDN
 * - Hover effect that enlarges the image
 * - Shows edition number overlay
 * - Automatic image compression during caching
 * - Error handling with imgErr fallback
 *
 * @param {Object} props - Component props
 * @param {Object} props.cDat - Collection data with id
 * @param {Object} props.item - Token data with id, image, meta
 * @param {Function} props.callback - Called with (collectionId, tokenId) on click
 * @param {Function} props.smt - Unused (legacy)
 * @returns {React.ReactElement} Thumbnail card with hover zoom effect
 */
function ZoomCard({cDat, item, callback, smt}) {


    // Safely access the pre-parsed meta object, defaulting to an empty object if it doesn't exist.
    const meta = item?.meta || {};

    const iu = useMemo(() => {
        if (!item?.image) {
            return null;
        }
        const cleanedUrl = cleanUrl(item.image, false);
        const hash = ipfs2md5(cleanedUrl, false);
        const primary = `https://cdn.stealthisnft.xyz/c/${hash.substring(0, 2)}/${hash}.jpg`;
        const fallback = `https://nftstorage.link${cleanedUrl}`;
        return { primary, fallback };
    }, [item?.image]);

    async function cacheImage(r, d, i, e){
        fetch(r)
            .then(res => res.blob())
            .then(async blob => {
                const file = new File([blob], r.replace(stripFile(r)), blob)
                try {
                    // toast("pulled image from ipfs")
                    //let file = await imageConversion.dataURLtoFile(cfile);
                    let divisor = 0.8;
                    if (file.type === "image/jpeg") {
                        divisor = 0.7
                    }
                    if (file?.size < 70000) {
                        divisor = 1
                    }
                    if (file?.size > 500000) {
                        divisor = 0.4
                    }
                    let targetSize=Math.floor((file?.size / 2048) * divisor);
                    if(targetSize > 500) targetSize=500;
                    imageConversion.compressAccurately(file, {
                        size: targetSize,
                        accuracy: 0.9,
                        type: "image/jpeg",
                    }).then(async res => {

                        try {
                            let nimg = await imageConversion.filetoDataURL(res)
                            // toast("img convert ok")
                            //setID(nimg)
                            const upload = {
                                collID: cDat?.id,
                                edition: item?.id,
                                cachefn: ipfs2md5(cleanUrl(r, false), false),
                                clean: cleanUrl(r, false),
                                imageFile: nimg.split(";base64,")[1],
                            };

                            await uploadToCache({ upload });
                            // //           setIU(false)
                        } catch (err) {
                   //         toast.error(JSON.stringify(err))
                        }
                    })
                        .catch((err) => {console.log("AddtoCache: ")})

                } catch (e) {

                }
            })

    }

    return (
        <> {iu ?
            <div
                id={"_id_" + cDat.id}
                onClick={() => {
                    callback(cDat?.id, item.id)
                }}
                style={{ marginBottom: "8px", marginRight: "8px", textAlign: "center", height: "69px", width: "69px"}}>

                <div>
                    <div id={"_zc_" + item?.id} className="text-light"
                         style={{minHeight: "69px", maxHeight: "69px",boxShadow:"1px 1px 3px 2px rgba(0,0,0,0.2)"}}
                         onMouseOver={async (thisItem) => {
                             await new Promise(r => setTimeout(r, 100));
                             let zcti = document.getElementById("_zc_" + item?.id)
                             //  zcti.parentElement.style.border = "2px solid purple";
                             zcti.style.zIndex = 50;
                             zcti.style.position = "absolute";
                             //thisItem.target.parentElement.parentElement.style.borderRadius = "8px";
                             zcti.style.maxHeight = "190px"
                             zcti.style.boxShadow = "10px 10px 15px 5px rgba(0,0,0,0.9)"
                             await new Promise(r => setTimeout(r, 500));
                             zcti.style.zIndex = 50;
                         }}
                         onMouseOut={async (thisItem) => {

                             await new Promise(r => setTimeout(r, 100));
                             let zcti = document.getElementById("_zc_" + item?.id)
                             zcti.style.zIndex = 25;
                             zcti.style.border = "0px";
                             zcti.style.maxHeight = "69px"
                             zcti.style.position = "relative";

                             zcti.style.boxShadow = "1px 1px 3px 2px rgba(0,0,0,0.2)"
                             await new Promise(r => setTimeout(r, 500));
                             zcti.style.zIndex = 0;

                         }}
                    >
                        <img
                            onMouseOver={null} onMouseOut={null}
                            id={Math.random()*100000}
                            style={{

                                borderRadius: "6px",
                                maxHeight: "inherit",
                                transition: "0.5s ease"
                            }}
                            src={iu?.primary}
                            onError={(e) => {
                              //  console.log("Calling iErr from zoomcard++"+e.target.id)
                                //iErr(e, cDat);
                          //  console.log("bobbeh" , item)
                                    imgErr(e, item)
                        }} alt={item?.id}/>
                        <div style={{background: "rgba(0,0,0,0.4)", fontWeight: "bold", fontSize: "12px", textShadow: "2px 2px black", position: "relative", top: "-17px"}}>
                        #{item?.id}
                        </div>
                    </div>

                </div>
            </div>
            : null}
        </>
    )
}

export default ZoomCard;
